import React from "react"

export default props => (
  <div className="overlayTag position-absolute">
    <p className="py-1 px-3">{props.title}</p>
  </div>
)
